import React, { FC } from 'react'

import { IconSocialTwitterProps } from './IconSocialTwitter.types'
import * as Styled from './styles/IconSocialTwitter.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSocialTwitter: FC<IconSocialTwitterProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSocialTwitterProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconSocialTwitterProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'>
        <path d='M500.4 94.8c-8 3.6-16.3 6.6-24.8 9 10-11.3 17.6-24.6 22.3-39.2 1-3.3 0-6.8-2.7-9-2.7-2.1-6.4-2.4-9.4-.6-17.9 10.6-37.3 18.3-57.6 22.8-20.4-20-48.2-31.4-76.9-31.4-60.6 0-109.9 49.3-109.9 109.9 0 4.8.3 9.5.9 14.2C167.1 163.9 97.2 126.9 49.2 68c-1.7-2.1-4.3-3.2-7-3-2.7.2-5.1 1.7-6.5 4.1-9.7 16.7-14.9 35.8-14.9 55.3 0 26.5 9.5 51.6 26.2 71.2-5.1-1.8-10-4-14.7-6.6-2.5-1.4-5.6-1.4-8.1.1-2.5 1.4-4.1 4.1-4.2 7v1.5c0 39.5 21.3 75.1 53.8 94.5-2.8-.3-5.6-.7-8.4-1.2-2.9-.5-5.8.5-7.7 2.6-1.9 2.2-2.6 5.2-1.7 8 12 37.6 43 65.2 80.5 73.7-31.1 19.5-66.6 29.7-103.9 29.7-7.8 0-15.6-.5-23.3-1.4-3.8-.5-7.4 1.8-8.7 5.4-1.3 3.6.1 7.7 3.3 9.7 47.9 30.7 103.4 47 160.3 47 111.9 0 181.9-52.8 220.9-97 48.7-55.2 76.6-128.3 76.6-200.5 0-3 0-6.1-.1-9.1 19.2-14.5 35.7-32 49.2-52.1 2-3.1 1.8-7.1-.5-9.9-2.6-2.8-6.5-3.7-9.9-2.2z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconSocialTwitter
